<template>
    <div id="report-customer-satisfaction">
        <div class="overall-content">
            <div class="chart-container">
                <div class="chart-section">
                    <div class="title">
                        <ChartDoddleIcon />
                        <h2>{{ $t("report.ratingOverall") }}</h2>
                    </div>
                    <OverallRatingChart title="Customer Rating Timeseries" :filters="filters" />
                </div>
                <a-divider />
                <div class="chart-section">
                    <div class="title">
                        <ChartDoddleIcon />
                        <h2>{{ $t('report.agentWaitDurationTitle') }}</h2>
                    </div>
                    <AgentWaitDurationTimeseries :title="$t('report.agentWaitDurationTitle')" :filters="filters" />
                </div>
                <a-divider />
                <div class="chart-section">
                    <div class="title">
                        <ChartDoddleIcon />
                        <h2>{{ $t('report.topComments') }}</h2>
                    </div>
                    <TopComments :title="$t('report.topComments')" :filters="filters" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import log2 from "../../../utils/log2";
import moment from "moment";
import OverallRatingChart from "../overall/OverallRatingChart.vue";
import AgentWaitDurationTimeseries from "./AgentWaitDurationTimeseries.vue";
import ChartDoddleIcon from "../common/icons/ChartDoddleIcon.vue";
import TopComments from "./TopComments.vue";

const log = log2("CustomerSatisfaction");
export default {
    name: "CustomerSatisfaction",
    components: {
        TopComments,
        ChartDoddleIcon,
        AgentWaitDurationTimeseries,
        OverallRatingChart,
    },
    props: {
        loading: {
            type: Boolean,
            default: true,
        },
        filters: {
            type: Object,
            default: () => ({
                users: [],
                channels: [],
                startDate: moment().startOf("day").toISOString(),
                endDate: moment().endOf("day").toISOString(),
            }),
        },
    },
};
</script>
<style lang="scss" scoped>
#report-customer-satisfaction {
    width: 100%;
    height: auto;
    min-height: 100vh;
    display: flex;

    .md-progress-bar {
        position: absolute;
        top: 0;
        width: 100%;
        margin-left: -10px;
    }

    .side-menubar-wrapper {
        min-height: 100vh;
        flex: 0 0 15%;
        height: 100%;
    }

    .overall-content {
        padding: 10px;
        display: flex;
        flex-direction: column;
        position: relative;
        background: white;
        width: 100%;
        height: 100%;
        min-height: 100vh;
        position: relative;

        .chart-container {
            width: 100%;
            display: flex;
            flex-direction: column;
            gap: 20px;

            .chart-section {
                display: flex;
                flex-direction: column;
                gap: 10px;

                .title {
                    display: flex;
                    gap: 4px;
                    align-items: center;

                    justify-content: center;

                    h2 {
                        text-align: center;
                        font-weight: 700;
                        font-size: 40px;
                        margin: 0 !important;
                    }
                }
            }

            .header {
                width: 100%;
            }

            .chart {
                max-width: 1050px;
            }
        }
    }
}
</style>
